module.exports = __webpack_public_path__ + "img/564.87df6acb.png";